import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight, Check } from 'lucide-react';
import ScrollToTop from '../../components/layout/ScrollToTop';
import { ScatterController } from 'chart.js';

const SubmitProductConfirmation = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <ScrollToTop />
     

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-4">
            <Check className="h-8 w-8 text-green-600" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Application Submitted Successfully!</h1>
          <p className="text-lg text-gray-600">
            Thank you for submitting your product. Here's what happens next:
          </p>
        </div>

        <div className="space-y-6">
          {[
            {
              step: 1,
              title: "Application Review",
              description: "Our team will review your submission within 2 business days",
              timeframe: "2 business days"
            },
            {
              step: 2,
              title: "Confirmation Email",
              description: "You'll receive an email with your scheduled launch date and next steps",
              timeframe: "Within 3 business days"
            },
            {
              step: 3,
              title: "Profile Setup",
              description: "Complete your company profile and prepare marketing materials",
              timeframe: "5-7 business days"
            },
            {
              step: 4,
              title: "Launch Preparation",
              description: "Final review and preparation for your product launch",
              timeframe: "1-2 business days before launch"
            }
          ].map((item) => (
            <div key={item.step} className="bg-white rounded-lg border p-6 flex items-start space-x-4">
              <div className="flex-shrink-0 w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                <span className="text-purple-600 font-semibold">{item.step}</span>
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-lg text-gray-900 mb-1">{item.title}</h3>
                <p className="text-gray-600 mb-2">{item.description}</p>
                <span className="inline-flex items-center rounded-full bg-purple-50 px-2.5 py-0.5 text-xs font-medium text-purple-700">
                  {item.timeframe}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 flex justify-between">
          <Link 
            to="/launch/submit-product"
            className="inline-flex items-center text-sm font-medium text-gray-600 hover:text-gray-900"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Link>
          <Link 
            to="/dashboard/performance"
            className="inline-flex items-center px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
          >
            Go to Dashboard
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </div>
      </main>
    </div>
  );
};

export default SubmitProductConfirmation;